<template>
  <div></div>
</template>

<script>
export default {
  name: 'Solution',
}
</script>

<style scoped lang="scss"></style>
